export enum HttpMethod {
  GET = 'GET',
  POST = 'POST'
}
